import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import { checkHttpStatus, parseJSON } from '../utils/helpers';
import constants from '../constants';

const { LOGIN_USER_REQUEST, LOGIN_USER_FAILURE, LOGIN_USER_SUCCESS, LOGOUT_USER } = constants;

export const loginUserSuccess = token => {
  localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, token);

  return {
    type: LOGIN_USER_SUCCESS,
    payload: {
      token,
    },
  };
};

export const loginUserFailure = () => {
  localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);

  return {
    type: LOGIN_USER_FAILURE,
  };
};

export const loginUserRequest = () => ({
  type: LOGIN_USER_REQUEST,
});

export const logout = () => {
  localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);

  return {
    type: LOGOUT_USER,
  };
};

export const logoutAndRedirect = () => dispatch => {
  dispatch(logout());
  dispatch(push('/'));
};

export const loginUser = (credentials, redirect = '/') => dispatch => {
  dispatch(loginUserRequest());

  return fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  })
    .then(checkHttpStatus)
    .then(parseJSON)
    .then(response => {
      const { token } = response.data;

      dispatch(loginUserSuccess(token));

      dispatch(push(redirect));
    })
    .catch(error => {
      const { response } = error;

      if (response) {
        response.json().then(err => {
          if (err.message) {
            toastr.error(err.message);
          }

          dispatch(loginUserFailure());
        });
      }
    });
};



// WEBPACK FOOTER //
// ./src/actions/auth.js